const GetHelpButton = ({ setOpen }: { setOpen: (value: boolean) => void }) => {
    return (
        <div className="get-help">
            <button
                type="button"
                style={{ backgroundColor: 'rgb(33,150,243)' }}
                className="btn btn-primary btn-sm"
                onClick={() => setOpen(true)}
            >
                Get Help
            </button>
        </div>
    );
};

export default GetHelpButton;
